export { default as message } from './message.svg';
export { default as notification } from './notification.svg';
export { default as person } from './person.svg';

